let _jsPDF = null
let _autoTable = null

export async function loadJsPDF() {
  if (_jsPDF) return _jsPDF
  const mod = await import('jspdf')
  const atMod = await import('jspdf-autotable')
  _jsPDF = mod.jsPDF
  _autoTable = atMod.autoTable
  return _jsPDF
}

export function getAutoTable() {
  return _autoTable
}
